import React, { useState, Component, Suspense } from 'react';
import styled from "styled-components";
import Axios from 'axios';
import { clearInterval } from 'timers';
import {wrapperEndPoint} from "../../../Utils/Api";

const Carousel_container = styled.div`
  width: 100%;
`
const Cards_slider = styled.div`
  position: relative;
  margin-left: 16px; //12
  padding-left:20px;
  white-space: nowrap;
  overflow: hidden;
`
const Card = styled.div`
  position: relative;
  display: inline-block;
  background: #f7dede;
  width:90%;
  height:130px;
  // width:248px;
  // height:96px;
  margin-right: 20px;
  border-radius:10px;
  cursor: pointer; 
  transition: transform 0.2s;
  overflow:hidden;
  
`
const Btn_r = styled.div`
  position:absolute;
  width: 25px;
  height: 25px; 
  top:54px;
  right:23px;
  border-radius : 50%;
  border: 1px solid #b72c2c;
  background: white;
  color:#b72c2c;
  cursor:pointer;
  padding-left:8px;
  padding-top:2.5px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  z-index: 999;
`
const Btn_l = styled.div`
  position:absolute;
  width: 25px;
  height: 25px;
  top:54px;
  border-radius : 50%;
  border: 1px solid #b72c2c;
  background: white;
  color:#b72c2c;
  cursor:pointer;
  padding-left:8px;
  padding-top:2.5px;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
   z-index: 999;
   transform:translateX(-50%);
`
const Card_img =styled.img `
 width:100%; 
 height:100%;
  
`

class Display extends Component {

 constructor(props) {
    super(props);
    this.state = {
      currentCard: 1,
      position: 0,
      transitionTime:0,
      cardStyle: {
        transform: 'translateX(0px)',
        transition: 'all 0.4s ease'
      },
  
      width: 0,
      isAutoSliding:true,
      slideInterval:5000,
      slideTimer: 0,
      bannerData:[]  

    };
  }

  componentDidMount() {



    Axios.get(wrapperEndPoint.BannerActionURL ,{ withCredentials: false})                         
    .then(response => {

      this.setState({bannerData:response.data})
      this.init();

      console.log(response)
    })
    .catch(error => {
      console.log(error)
    })

  }

  componentWillUnmount(){
    clearTimeout(this.state.slideTimer);
    //clearInterval(this.state.slideTimer);
  }

  init(){

    
    let boxWidth = document.getElementById("card1").clientWidth;
    this.setState({ width: boxWidth });
    let slideTimer = setInterval(() => this.autoSlide(this.state.isAutoSliding), this.state.slideInterval);
    this.setState({
      slideTimer:slideTimer
    })
    document.getElementById('card' + this.state.currentCard).style.transition="transform 0s";
    document.getElementById('card' + this.state.currentCard).style.transform="scale(1)";
    document.getElementById('card' + this.state.currentCard).style.opacity="1";
    setTimeout(() => {
      document.getElementById('card' + this.state.currentCard).style.transition="transform 0.4s ease";
    }, 400);

  }

  autoSlide(isAutoSliding){
   
    if (isAutoSliding === true && this.state.bannerData.length > 1){
      this.handleClick("next");
    }; 
   
  }
  
  // func: click the slider buttons
  handleClick(direction) {
    // get the card's margin-right
    let margin = window.getComputedStyle(document.getElementById("card1")).marginRight;
    margin = JSON.parse(margin.replace(/px/i, '')); 

    const cardWidth = this.state.width; // the card's width
    const cardMargin = margin; // the card's margin
    const cardNumber = this.state.bannerData.length; // the number of cards//here**
    let currentCard = this.state.currentCard; // the index of the current card
    let position = this.state.position; // the position of the cards
    let transitionTime = this.state.transitionTime;

    // slide cards
    
    if(direction === 'next') {
     
      transitionTime = 0.4;
      position = - (cardWidth+cardMargin);
      let activeCard = document.getElementById('card' + currentCard)
      let lastCard = document.getElementById("slider").lastChild;
     
      activeCard.style.transform="scale(0.9)";
      activeCard.style.opacity="0.7";

      setTimeout(() => {
        position = 0;//reset x position
        transitionTime = 0;// remove animation
       // lastCard.after(activeCard);
        lastCard.parentNode.insertBefore(activeCard, lastCard.nextSibling);
        this.setCard(currentCard, position, transitionTime);
      }, 400);

      if (currentCard == cardNumber){ 
      currentCard =1;
      }
      else {
        currentCard++;
      }

      document.getElementById('card' + currentCard).style.transform="scale(1)";
      document.getElementById('card' + currentCard).style.opacity="1";
      
      // let activeCard = document.getElementById('card' + currentCard);


    } else if(direction === 'prev') {

      transitionTime = 0;
      position = -(cardWidth+cardMargin);
      let activeCard = document.getElementById('card' + currentCard)
      let lastCard = document.getElementById("slider").lastChild;
      activeCard.before(lastCard);
      activeCard.style.transform="scale(0.9)";
      activeCard.style.opacity="0.7";
 
      setTimeout(() => {
        position = 0;
        transitionTime = 0.4;
        this.setCard(currentCard, position, transitionTime);
      }, 10);

      if (currentCard == 1){ 
        currentCard = cardNumber;
        }
        else {
          currentCard--;
        }
        document.getElementById('card' + currentCard).style.transform="scale(1)";
        document.getElementById('card' + currentCard).style.opacity="1";
    }
    this.setCard(currentCard, position, transitionTime);
  }
  
  setCard(currentCard, position, transitionTime) {
    this.setState({
      currentCard: currentCard,
      position: position,
      transitionTime:transitionTime,
      cardStyle: {
        transform: `translateX(${position}px)`,
        transition: `all ${transitionTime}s ease`,
      }
    })
  }

  render() {
    return (
      <div>{this.state.bannerData.length !== 0?

        <div>        
        <Carousel_container>
        <Cards_slider 
        onMouseEnter={() => this.setState({isAutoSliding:false,}) } 
        onMouseLeave={() => this.setState({isAutoSliding:true,}) }
        >
          <div> {this.state.bannerData.length > 1? 
            <div>
               <Btn_l onClick={() => this.handleClick('prev')}>&lt;</Btn_l>
               <Btn_r  onClick={() => this.handleClick('next')}>&gt;</Btn_r>
            </div>
            :null}
          
           </div>
          
              <Cards cardStyle={this.state.cardStyle} bannerData={this.state.bannerData}/>
            
        </Cards_slider>
        </Carousel_container></div>
        :null

      }

    </div>
    )
  }
}


class Cards extends Component {

  sendAnalyticsforBanner(i){


    let analyticsData = {name:this.props.bannerData[i].name,type:'Banner',action:this.props.bannerData[i].redirectLink ==''?this.props.bannerData[i].autoSubmit:this.props.bannerData[i].redirectLink,botid: "vYdoWvH2CVMbJOGnAB11VA=="}

    Axios.post(wrapperEndPoint.analyticsURL, analyticsData)
    .then(response => {
        console.log(response);//handle sucess
    }).catch(error => {
        console.log(error);//handle error
    });


  }

  componentDidMount(){

    this.props.bannerData.map((card, i) => {

    if(card.autoSubmit =="" && card.redirectLink ==""){
      document.getElementById(card.id).style.cursor = "not-allowed";
  
    }
  })

  }

  

  render() {     
    return (

    <div id="slider" style={this.props.cardStyle}>
    {
      this.props.bannerData.map((card, i) => {
      return (  
          <Card 
            style={{transform:'scale(0.9)', opacity:'0.7'}}
            id={card.id}  key={i} onClick={() => 
         
            { 
              { if(card.autoSubmit =="" && card.redirectLink ==""){
              }else if(card.autoSubmit != ""){
                window["autosubmit"](card.autoSubmit);
              }else if(card.redirectLink != ""){
                window.open(card.redirectLink);
              }
  
              this.sendAnalyticsforBanner(i)
            
              }
            }
            }>

            <Card_img src={card.image}></Card_img>
        
          </Card>
        
        )
      }
      )
    }
    </div>
    )
  }
}

export default Display;











